module.exports = __webpack_public_path__ + "static/media/logo-dark.6316dec6.png";